import { render } from "./HistoryOrder.vue?vue&type=template&id=847097be&scoped=true&ts=true"
import script from "./HistoryOrder.vue?vue&type=script&lang=ts"
export * from "./HistoryOrder.vue?vue&type=script&lang=ts"

import "./HistoryOrder.vue?vue&type=style&index=0&id=847097be&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-847097be"]])

export default __exports__